const URIs = {
    REGISTER : "/register",
    LOGIN : "/login",
    VERIFY : "/verify",
    SET_PASSWORD : "/set-password",
    KYC : "/kyc",
    MARKETS: "/markets",
    ADMIN: {
        ROOT: "/admin",
        ORDERS: "/admin/orders",  // Fixed path
        GOLD_BOX: "/admin/gold-box",  // Fixed path
        USERS: "/admin/users",  // Fixed path
        MENU: "/admin/menu",  // Fixed path
    },
    HOME: "/",
    GOLD_BOX: "/gold-box",
    TRANSACTOINS: "/transactions",
    WALLET: "/wallet",
    MENU: "/menu",
    ORDER: "/order",
}
export default URIs
